var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
var MISSING_ERROR = 'Error was swallowed during propagation.';
var ErrorBoundary = (function (_super) {
    __extends(ErrorBoundary, _super);
    function ErrorBoundary() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            error: undefined,
        };
        _this.logErrorToCloud = function (error, info) {
        };
        _this.handleReset = function () {
            _this.setState({ error: undefined });
        };
        return _this;
    }
    ErrorBoundary.prototype.componentDidCatch = function (error, info) {
        this.setState({ error: error || new Error(MISSING_ERROR) });
        this.logErrorToCloud(error, info);
    };
    ErrorBoundary.prototype.render = function () {
        var children = this.props.children;
        var error = this.state.error;
        if (error) {
            return (React.createElement("div", null,
                React.createElement("p", null, "Sorry there was an unexpected error"), "To continue: ",
                React.createElement("a", { href: "/" }, "refresh app")));
        }
        return children;
    };
    return ErrorBoundary;
}(React.Component));
export { ErrorBoundary };
